"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldTextAdaptor = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

const FieldTextAdaptor = ({
  input,
  meta,
  ...rest
}) => /*#__PURE__*/React.createElement(_blocks.FieldText, (0, _extends2.default)({}, input, rest, {
  onChange: value => input.onChange(value),
  error: meta.touched && meta.error ? meta.error : undefined
}));

exports.FieldTextAdaptor = FieldTextAdaptor;